import { render, staticRenderFns } from "./tags-filter.vue?vue&type=template&id=810bb29c"
import script from "./tags-filter.vue?vue&type=script&lang=js"
export * from "./tags-filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports